class SideElement {
  constructor(elem) {
    this.elem = elem;

    this.handleSidebySideMobileView();
    this.handleImageSwitch();

    window.addEventListener("resize", () => {
      this.handleSidebySideMobileView();
    });
  }

  handleImageSwitch() {
    const smallSideLinks = this.elem.querySelectorAll(".small-side a");

    smallSideLinks.forEach((link) => {
      ["touchstart", "click", "mouseenter"].forEach((eventType) => {
        link.addEventListener(eventType, (event) => {
          this.handleImageSwitchEvent(event, link);
        });
      });
    });
  }

  handleImageSwitchEvent(event, link) {
    event.preventDefault();

    const largeLink = link.getAttribute("href");
    const sideElement = link.closest(".side-element");

    this.updateDisplayLink(sideElement, largeLink);
    this.updateMediumImage(link, sideElement);
  }

  updateDisplayLink(sideElement, largeLink) {
    const displayLink = sideElement.querySelector(".side-image-display a");

    if (displayLink) {
      displayLink.setAttribute("href", largeLink);
    }

    // update the side-image-link href to match the hovered image
    const sideImageLink = sideElement.querySelector(".side-image-link");
    if (sideImageLink) {
      sideImageLink.setAttribute("href", largeLink);
    }
  }

  updateMediumImage(link, sideElement) {
    // get the small media element from the link
    const smallMedia = link.querySelector(".small-side-image");
    if (!smallMedia) return;

    // get the medium image container
    const mediumContainer = sideElement.querySelector(".side-image-link");
    if (!mediumContainer) return;

    // clone the small media element's content and then swap the classes on it
    const clone = smallMedia.cloneNode(true);

    clone.classList.remove("small-side-image");
    clone.classList.add("medium-side-image");

    const currentMediumElement =
      sideElement.querySelector(".medium-side-image");
    if (!currentMediumElement) return;

    // replace the current medium element with the clone
    mediumContainer.replaceChild(clone, currentMediumElement);

    if (clone.tagName.toLowerCase() === "video") {
      if (typeof clone.load === "function") {
        clone.load();
      }

      clone.play().catch((e) => console.warn("Could not play video:", e));
    }
  }

  handleSidebySideMobileView() {
    if (window.innerWidth <= 770) {
      const smallImages = this.elem.querySelectorAll(".small-side-image");
      smallImages.forEach((image) => {
        const src = image.getAttribute("src");
        if (src) {
          image.setAttribute("src", src.replace("thumb160", "medium640"));
        }
      });
    }
  }
}

// initialize for all side-elements
function initializeSideElements(selector) {
  const elements = document.querySelectorAll(selector);
  elements.forEach((element) => new SideElement(element));
}

export { initializeSideElements };
